// components/AnnouncementBanner.jsx
import React, {useEffect, useState} from "react";
import {getAnnouncements} from "../api";

function AnnouncementBanner() {
    const [text, setText] = useState("");

    useEffect(() => {
        getAnnouncements({active: true})
            .then((data) => {
                const first = Array.isArray(data) ? data[0] : null;
                const t = first?.text ?? null;
                if (t && String(t).trim() !== "") setText(String(t));
            })
            .catch(() => {
            });
    }, []);

    if (!text) return null;

    return (
        <div className="pointer-events-none select-none">
            <div
                className="
    fixed
    top-[250px]           /* schöner Abstand unterhalb Header */
    left-[0px]       /* weiter nach rechts */
    w-[500px]          /* breiteres Band */
    bg-red-600 text-white font-bold
    px-6 py-2
    transform -rotate-45 origin-top
    text-center shadow-lg
    pointer-events-none select-none
    text-lg sm:text-xl   /* 👈 Text vergrößert */
  "
                style={{ zIndex: 99999 }}
            >
                {text}
            </div>


        </div>
    );
}

export default AnnouncementBanner;
